import { isDefined } from "@clipboard-health/util-ts";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import z from "zod";

export function usePayoutRemainingBalance(options: { onPayoutSuccess?: () => Promise<void> }) {
  return useMutation({
    mutationFn: async () => {
      const result = await post({
        url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/authenticated/payout`,
        responseSchema: z.any(),
      });

      if (isDefined(options.onPayoutSuccess)) {
        await options.onPayoutSuccess();
      }

      return result;
    },
    onSuccess: () => {
      enqueueSnackbar({
        variant: "success",
        message: "Payout initiated successfully!",
      });
    },
    onError: (error) => {
      const message =
        isAxiosError(error) &&
        error.status === 400 &&
        isDefined(error.response) &&
        typeof error.response.data.message === "string"
          ? (error.response.data.message as string)
          : "Payout failed. Please contact support team for assistance";

      enqueueSnackbar({
        variant: "error",
        message,
      });

      logEvent(APP_V2_APP_EVENTS.PAYOUT_REMAINING_BALANCE_FAILURE, { error });
    },
  });
}
